// JAZ Sales - Phase 2 (leads, campaigns, pipeline) strings, merged into the Sales dictionary by salesTranslations.js.
// Arabic and English are equal partners: every key exists in both (tests/scripts check that), and every placeholder
// ({n}, {name}, ...) appears in both languages.
export const leadsTranslations = {
  ar: {
    nav_leads: 'العملاء المحتملون',
    nav_pipeline: 'مسار المبيعات',
    nav_campaigns: 'الحملات',

    // ---- shared
    none: 'بدون',
    unassigned: 'غير مُعيَّن',
    field_optional: 'اختياري',
    required_hint: 'الحقول المُعلَّمة بعلامة * إلزامية.',
    action_back: 'رجوع',
    action_back_to_leads: 'العودة إلى العملاء المحتملين',
    action_back_to_lead: 'العودة إلى العميل المحتمل',
    action_delete: 'حذف',
    action_prev: 'السابق',
    action_next: 'التالي',
    action_load_more: 'عرض المزيد',
    action_change_stage: 'تغيير المرحلة',
    action_assign: 'تعيين',
    action_reassign: 'إعادة تعيين',
    action_unassign: 'إلغاء التعيين',
    action_archive: 'أرشفة',
    action_restore: 'استعادة',
    pagination: 'التنقل بين الصفحات',
    pagination_page: 'صفحة {page} من {pages}',
    home_foundation_body: 'اختر قسماً من القائمة للبدء.',

    // ---- pipeline vocabulary
    stage_new: 'جديد',
    stage_assigned: 'تم التعيين',
    stage_contacted: 'تم التواصل',
    stage_interested: 'مهتم',
    stage_demo_scheduled: 'عرض تجريبي مجدول',
    stage_demo_completed: 'تم العرض التجريبي',
    stage_trial: 'فترة تجريبية',
    stage_negotiation: 'تفاوض',
    stage_won: 'تم الفوز',
    stage_lost: 'خسارة',
    priority_low: 'منخفضة',
    priority_medium: 'متوسطة',
    priority_high: 'عالية',
    lost_too_expensive: 'السعر مرتفع',
    lost_not_interested: 'غير مهتم',
    lost_already_using_another_system: 'يستخدم نظاماً آخر',
    lost_no_response: 'لا يوجد رد',
    lost_wrong_number: 'رقم خاطئ',
    lost_business_closed: 'النشاط مغلق',
    lost_not_suitable: 'غير مناسب',
    lost_delayed_decision: 'تأجيل القرار',
    lost_competitor: 'اختار منافساً',
    lost_other: 'سبب آخر',
    campaign_status_active: 'نشطة',
    campaign_status_paused: 'متوقفة مؤقتاً',
    campaign_status_completed: 'مكتملة',

    // ---- lead fields
    lead_field_business_name: 'اسم النشاط التجاري',
    lead_field_business_type: 'نوع النشاط',
    lead_field_description: 'الوصف',
    lead_field_contact_name: 'اسم جهة الاتصال',
    lead_field_contact_position: 'المنصب',
    lead_field_phone: 'الهاتف',
    lead_field_whatsapp: 'واتساب',
    lead_field_email: 'البريد الإلكتروني',
    lead_field_website: 'الموقع الإلكتروني',
    lead_field_country: 'الدولة',
    lead_field_city: 'المدينة',
    lead_field_address: 'العنوان',
    lead_field_latitude: 'خط العرض',
    lead_field_longitude: 'خط الطول',
    lead_field_coordinates: 'الإحداثيات',
    lead_field_source: 'المصدر',
    lead_field_campaign: 'الحملة',
    lead_field_priority: 'الأولوية',
    lead_field_estimated_value: 'القيمة التقديرية',
    lead_field_notes: 'ملاحظات',
    lead_field_pipeline_stage: 'المرحلة',
    lead_field_assigned_to: 'المسؤول',
    lead_field_lost_reason: 'سبب الخسارة',

    // ---- leads list
    leads_title: 'العملاء المحتملون',
    leads_add: 'إضافة عميل محتمل',
    leads_showing: 'عرض {from}–{to} من {total}',
    leads_empty: 'لا يوجد عملاء محتملون بعد',
    leads_empty_hint: 'أضف أول عميل محتمل للبدء.',
    leads_empty_filtered: 'لا توجد نتائج مطابقة',
    leads_empty_filtered_hint: 'جرّب تغيير عوامل التصفية أو البحث.',
    leads_error: 'تعذر تحميل البيانات',
    leads_col_business: 'النشاط التجاري',
    leads_col_contact: 'جهة الاتصال',
    leads_col_created: 'تاريخ الإضافة',
    filter_all: 'الكل',
    filter_stage: 'مراحل المبيعات',
    filter_search: 'بحث',
    filter_search_placeholder: 'الاسم أو الهاتف أو واتساب أو البريد أو جهة الاتصال',
    filter_assigned: 'المسؤول',
    filter_assigned_me: 'المُعيَّنة لي',
    filter_unassigned: 'غير المُعيَّنة',
    filter_created_from: 'أُضيف من',
    filter_created_to: 'أُضيف إلى',
    filter_sort: 'ترتيب حسب',
    filter_archived: 'الحالة',
    filter_archived_active: 'النشطة فقط',
    filter_archived_only: 'المؤرشفة فقط',
    filter_archived_all: 'النشطة والمؤرشفة',
    filter_reset: 'مسح عوامل التصفية',
    sort_created_at: 'تاريخ الإضافة',
    sort_updated_at: 'آخر تحديث',
    sort_business_name: 'الاسم',
    sort_priority: 'الأولوية',
    sort_estimated_value: 'القيمة التقديرية',
    sort_pipeline_stage: 'المرحلة',
    sort_asc: 'تصاعدي',
    sort_desc: 'تنازلي',
    bulk_selected: 'تم تحديد {n}',
    bulk_assign: 'تعيين المحدد',
    bulk_clear: 'إلغاء التحديد',
    bulk_select_all: 'تحديد كل العملاء في هذه الصفحة',
    bulk_select_one: 'تحديد',
    lead_archived_tag: 'مؤرشف',
    assignee_inactive: 'حساب معطّل',

    // ---- lead page
    lead_section_business: 'النشاط التجاري',
    lead_section_contact: 'جهة الاتصال',
    lead_section_location: 'الموقع',
    lead_section_sales: 'المبيعات',
    lead_section_pipeline: 'مسار المبيعات',
    lead_section_timeline: 'السجل الزمني',
    lead_created_by: 'أضافه',
    lead_updated_at: 'آخر تحديث',
    lead_assigned_on: 'منذ {date}',
    lead_won_on: 'تم الفوز بتاريخ {date}',
    lead_archived_banner: 'هذا العميل المحتمل مؤرشف. استعِده لإجراء أي تعديل.',
    lead_not_found: 'العميل المحتمل غير موجود',
    lead_load_error: 'تعذر تحميل العميل المحتمل',
    lead_archived_readonly: 'هذا العميل المحتمل مؤرشف. استعِده أولاً لتعديله.',
    lead_not_editable: 'ليست لديك صلاحية تعديل هذا العميل المحتمل.',
    lead_no_changes: 'لا توجد تغييرات لحفظها',
    lead_create_title: 'عميل محتمل جديد',
    lead_edit_title: 'تعديل العميل المحتمل',
    lead_create_submit: 'إنشاء العميل المحتمل',
    lead_assign_now: 'تعيين إلى',
    lead_assign_now_hint: 'اختياري. يمكنك التعيين لاحقاً من صفحة العميل.',
    confirm_archive: 'سيتم إخفاء هذا العميل المحتمل من القوائم مع بقاء سجله كاملاً، ويمكن استعادته لاحقاً. هل أنت متأكد؟',
    confirm_unassign: 'إلغاء تعيين هذا العميل المحتمل من الموظف الحالي؟',
    toast_lead_created: 'تم إنشاء العميل المحتمل',
    toast_lead_updated: 'تم حفظ التعديلات',
    toast_lead_archived: 'تمت أرشفة العميل المحتمل',
    toast_lead_restored: 'تمت استعادة العميل المحتمل',
    toast_assigned: 'تم تعيين العميل المحتمل',
    toast_assign_unchanged: 'العميل المحتمل مُعيَّن لهذا الموظف بالفعل',
    toast_unassigned: 'تم إلغاء التعيين',
    toast_bulk_assigned: 'تم تعيين {n} وتخطي {u} (مُعيَّنة مسبقاً)',
    toast_stage_updated: 'تم تحديث المرحلة',

    // ---- stage dialog
    stage_dialog_title: 'تغيير المرحلة',
    stage_move_to: 'الانتقال إلى',
    stage_lost_reason: 'سبب الخسارة',
    stage_lost_reason_placeholder: 'اختر السبب',
    stage_note: 'ملاحظة',
    stage_confirm: 'تأكيد التغيير',
    stage_won_terminal: 'هذا العميل المحتمل في مرحلة "تم الفوز" ولا يمكن نقله إلى مرحلة أخرى.',
    stage_no_moves: 'لا توجد مراحل متاحة لهذا العميل المحتمل حالياً.',
    stage_reopen_hint: 'هذا العميل المحتمل مُصنَّف كخسارة. يمكنك إعادة فتحه بإعادته إلى مرحلة أولية.',
    stage_assign_first_hint: 'عيّن العميل المحتمل إلى موظف مبيعات أولاً ليتمكن من متابعة المراحل، أو أغلقه كخسارة.',

    // ---- assign dialog
    assign_title: 'تعيين العميل المحتمل',
    assign_title_bulk: 'تعيين {n} عميل محتمل',
    assign_hint: 'يظهر هنا الموظفون النشطون الذين يمكنهم استلام العملاء المحتملين، مع عدد العملاء المفتوحين لدى كل منهم.',
    assign_pick: 'اختر الموظف',
    assign_search: 'بحث في الموظفين',
    assign_no_match: 'لا يوجد موظف مطابق',
    assign_none: 'لا يوجد حالياً موظف يمكنه استلام عملاء محتملين.',
    assign_current: 'المسؤول الحالي',
    assign_open_leads: '{n} مفتوح',
    assign_confirm: 'تعيين',

    // ---- duplicates
    dup_title_exact: 'تم العثور على تكرار مؤكد',
    dup_title_possible: 'تم العثور على تطابق محتمل',
    dup_intro_exact: 'يبدو أن هذا عميل محتمل أو عميل موجود لدينا بالفعل. راجع السجل الموجود قبل إنشاء سجل آخر.',
    dup_intro_possible: 'وُجدت سجلات مشابهة. راجعها للتأكد من أنه ليس النشاط نفسه.',
    dup_live_hint: 'يمكنك المتابعة، وسيُطلب منك التأكيد عند الحفظ.',
    dup_kind_exact: 'مؤكد',
    dup_kind_possible: 'محتمل',
    dup_leads: 'عملاء محتملون موجودون',
    dup_companies: 'عملاء JAZ الحاليون',
    dup_archived: 'مؤرشف',
    dup_owned: 'مُعيَّن إلى {name}',
    dup_owned_other: 'مُعيَّن إلى زميل',
    dup_unassigned: 'غير مُعيَّن',
    dup_no_access: 'ليست لديك صلاحية فتح هذا العميل المحتمل',
    dup_open: 'فتح',
    dup_confirm_create: 'إنشاء رغم التكرار',
    dup_confirm_save: 'حفظ رغم التكرار',
    dup_needs_manager: 'لا يمكن المتابعة: هناك تكرار مؤكد، ويحتاج إلى مراجعة مدير المبيعات.',
    dup_similar_number: '(رقم مشابه، قد يختلف رمز الدولة)',
    dup_r_phone_phone: 'نفس رقم الهاتف',
    dup_r_phone_whatsapp: 'الهاتف يطابق رقم واتساب لديه',
    dup_r_whatsapp_whatsapp: 'نفس رقم واتساب',
    dup_r_whatsapp_phone: 'واتساب يطابق رقم هاتفه',
    dup_r_email_email: 'نفس البريد الإلكتروني',
    dup_r_website_website: 'نفس الموقع الإلكتروني',
    dup_r_business_name_business_name_city: 'نفس الاسم في نفس المدينة',
    dup_r_email_owner_email: 'بريد مالك شركة عميلة في JAZ',
    dup_r_phone_owner_phone: 'هاتف مالك شركة عميلة في JAZ',
    dup_r_whatsapp_owner_phone: 'واتساب يطابق هاتف مالك شركة عميلة في JAZ',
    dup_r_business_name_company_name: 'نفس اسم شركة عميلة في JAZ',

    // ---- timeline
    lead_section_timeline_hint: 'سجل غير قابل للتعديل بكل ما جرى على هذا العميل المحتمل.',
    timeline_empty: 'لا توجد أحداث بعد',
    timeline_empty_value: 'فارغ',
    timeline_by: 'بواسطة',
    timeline_automatic: 'تلقائي',
    timeline_reopened: 'إعادة فتح',
    timeline_nobody: 'لا أحد',
    timeline_dup_override: 'أُنشئ رغم {n} تطابق(ات) تم تأكيدها',
    event_lead_created: 'تم إنشاء العميل المحتمل',
    event_lead_updated: 'تم تعديل البيانات',
    event_lead_assigned: 'تم تعيين العميل المحتمل',
    event_lead_reassigned: 'تمت إعادة التعيين',
    event_lead_unassigned: 'تم إلغاء التعيين',
    event_stage_changed: 'تغيّرت المرحلة',
    event_lead_marked_won: 'تم تسجيله كفوز',
    event_lead_marked_lost: 'تم تسجيله كخسارة',
    event_lead_archived: 'تمت الأرشفة',
    event_lead_restored: 'تمت الاستعادة',

    // ---- campaigns
    campaigns_title: 'الحملات',
    campaigns_add: 'إضافة حملة',
    campaigns_view_only: 'عرض فقط - إدارة الحملات متاحة لمدير المبيعات',
    campaigns_search_placeholder: 'اسم الحملة أو وصفها',
    campaigns_empty: 'لا توجد حملات بعد',
    campaigns_empty_filtered: 'لا توجد حملات مطابقة',
    campaigns_error: 'تعذر تحميل الحملات',
    campaign_field_name: 'اسم الحملة',
    campaign_field_description: 'الوصف',
    campaign_field_status: 'الحالة',
    campaign_field_start: 'تاريخ البداية',
    campaign_field_end: 'تاريخ النهاية',
    campaign_dates: 'الفترة',
    campaign_leads: 'العملاء المحتملون',
    campaign_create_title: 'حملة جديدة',
    campaign_edit_title: 'تعديل الحملة',
    confirm_delete_campaign: 'حذف الحملة "{name}"؟ لا يمكن حذف حملة لها عملاء محتملون.',
    toast_campaign_created: 'تم إنشاء الحملة',
    toast_campaign_updated: 'تم حفظ الحملة',
    toast_campaign_deleted: 'تم حذف الحملة',

    // ---- pipeline board
    pipeline_title: 'مسار المبيعات',
    pipeline_subtitle: 'العملاء المحتملون موزّعون على مراحل المبيعات، الأحدث تعديلاً أولاً.',
    pipeline_empty_column: 'لا يوجد عملاء',
    pipeline_view_all: 'عرض كل الـ {n}',

    // ---- errors (by server error code)
    err_forbidden: 'ليست لديك صلاحية لتنفيذ هذا الإجراء',
    err_not_found: 'العنصر المطلوب غير موجود',
    err_lead_archived: 'هذا العميل المحتمل مؤرشف. استعِده لإجراء أي تعديل.',
    err_assignee_not_eligible: 'لا يمكن تعيين العميل المحتمل لهذا الشخص. يجب أن يكون موظف مبيعات نشطاً يعمل على العملاء المحتملين.',
    err_transition_not_allowed: 'لا يمكن نقل العميل المحتمل إلى هذه المرحلة من مرحلته الحالية.',
    err_same_stage: 'العميل المحتمل في هذه المرحلة بالفعل.',
    err_assignee_required: 'عيّن العميل المحتمل إلى موظف مبيعات قبل نقله إلى هذه المرحلة.',
    err_unassign_required: 'ألغِ تعيين العميل المحتمل قبل إعادته إلى مرحلة "جديد".',
    err_lost_reason_required: 'يجب اختيار سبب الخسارة.',
    err_lost_reason_not_allowed: 'سبب الخسارة يُحدَّد فقط عند تصنيف العميل كخسارة.',
    err_invalid_lost_reason: 'سبب الخسارة غير معروف.',
    err_campaign_has_leads: 'لا يمكن حذف هذه الحملة لأنها تضم {n} عميلاً محتملاً. عيّن حالتها "مكتملة" بدلاً من ذلك.',
    err_duplicates_found: 'وُجدت سجلات مكررة. راجعها ثم أكّد للمتابعة.',
    err_duplicate_override_forbidden: 'التكرار المؤكد يحتاج إلى مراجعة مدير المبيعات.',
    err_leads_not_found: 'بعض العملاء المحتملين غير موجودين.',
  },

  en: {
    nav_leads: 'Leads',
    nav_pipeline: 'Pipeline',
    nav_campaigns: 'Campaigns',

    // ---- shared
    none: 'None',
    unassigned: 'Unassigned',
    field_optional: 'optional',
    required_hint: 'Fields marked * are required.',
    action_back: 'Back',
    action_back_to_leads: 'Back to leads',
    action_back_to_lead: 'Back to the lead',
    action_delete: 'Delete',
    action_prev: 'Previous',
    action_next: 'Next',
    action_load_more: 'Load more',
    action_change_stage: 'Change stage',
    action_assign: 'Assign',
    action_reassign: 'Reassign',
    action_unassign: 'Unassign',
    action_archive: 'Archive',
    action_restore: 'Restore',
    pagination: 'Pagination',
    pagination_page: 'Page {page} of {pages}',
    home_foundation_body: 'Choose a section from the menu to get started.',

    // ---- pipeline vocabulary
    stage_new: 'New',
    stage_assigned: 'Assigned',
    stage_contacted: 'Contacted',
    stage_interested: 'Interested',
    stage_demo_scheduled: 'Demo scheduled',
    stage_demo_completed: 'Demo completed',
    stage_trial: 'Trial',
    stage_negotiation: 'Negotiation',
    stage_won: 'Won',
    stage_lost: 'Lost',
    priority_low: 'Low',
    priority_medium: 'Medium',
    priority_high: 'High',
    lost_too_expensive: 'Too expensive',
    lost_not_interested: 'Not interested',
    lost_already_using_another_system: 'Already using another system',
    lost_no_response: 'No response',
    lost_wrong_number: 'Wrong number',
    lost_business_closed: 'Business closed',
    lost_not_suitable: 'Not suitable',
    lost_delayed_decision: 'Delayed decision',
    lost_competitor: 'Chose a competitor',
    lost_other: 'Other',
    campaign_status_active: 'Active',
    campaign_status_paused: 'Paused',
    campaign_status_completed: 'Completed',

    // ---- lead fields
    lead_field_business_name: 'Business name',
    lead_field_business_type: 'Business type',
    lead_field_description: 'Description',
    lead_field_contact_name: 'Contact name',
    lead_field_contact_position: 'Position',
    lead_field_phone: 'Phone',
    lead_field_whatsapp: 'WhatsApp',
    lead_field_email: 'Email',
    lead_field_website: 'Website',
    lead_field_country: 'Country',
    lead_field_city: 'City',
    lead_field_address: 'Address',
    lead_field_latitude: 'Latitude',
    lead_field_longitude: 'Longitude',
    lead_field_coordinates: 'Coordinates',
    lead_field_source: 'Source',
    lead_field_campaign: 'Campaign',
    lead_field_priority: 'Priority',
    lead_field_estimated_value: 'Estimated value',
    lead_field_notes: 'Notes',
    lead_field_pipeline_stage: 'Stage',
    lead_field_assigned_to: 'Assigned to',
    lead_field_lost_reason: 'Lost reason',

    // ---- leads list
    leads_title: 'Leads',
    leads_add: 'Add lead',
    leads_showing: 'Showing {from}–{to} of {total}',
    leads_empty: 'No leads yet',
    leads_empty_hint: 'Add your first lead to get started.',
    leads_empty_filtered: 'No matching leads',
    leads_empty_filtered_hint: 'Try changing the filters or the search.',
    leads_error: 'Could not load the data',
    leads_col_business: 'Business',
    leads_col_contact: 'Contact',
    leads_col_created: 'Added',
    filter_all: 'All',
    filter_stage: 'Pipeline stages',
    filter_search: 'Search',
    filter_search_placeholder: 'Name, phone, WhatsApp, email or contact',
    filter_assigned: 'Assigned to',
    filter_assigned_me: 'Assigned to me',
    filter_unassigned: 'Unassigned',
    filter_created_from: 'Added from',
    filter_created_to: 'Added to',
    filter_sort: 'Sort by',
    filter_archived: 'Status',
    filter_archived_active: 'Active only',
    filter_archived_only: 'Archived only',
    filter_archived_all: 'Active and archived',
    filter_reset: 'Clear filters',
    sort_created_at: 'Date added',
    sort_updated_at: 'Last updated',
    sort_business_name: 'Name',
    sort_priority: 'Priority',
    sort_estimated_value: 'Estimated value',
    sort_pipeline_stage: 'Stage',
    sort_asc: 'Ascending',
    sort_desc: 'Descending',
    bulk_selected: '{n} selected',
    bulk_assign: 'Assign selected',
    bulk_clear: 'Clear selection',
    bulk_select_all: 'Select all leads on this page',
    bulk_select_one: 'Select',
    lead_archived_tag: 'Archived',
    assignee_inactive: 'deactivated account',

    // ---- lead page
    lead_section_business: 'Business',
    lead_section_contact: 'Contact',
    lead_section_location: 'Location',
    lead_section_sales: 'Sales',
    lead_section_pipeline: 'Pipeline',
    lead_section_timeline: 'Activity timeline',
    lead_created_by: 'Added by',
    lead_updated_at: 'Last updated',
    lead_assigned_on: 'since {date}',
    lead_won_on: 'Won on {date}',
    lead_archived_banner: 'This lead is archived. Restore it to make any change.',
    lead_not_found: 'Lead not found',
    lead_load_error: 'Could not load the lead',
    lead_archived_readonly: 'This lead is archived. Restore it first to edit it.',
    lead_not_editable: "You don't have permission to edit this lead.",
    lead_no_changes: 'There are no changes to save',
    lead_create_title: 'New lead',
    lead_edit_title: 'Edit lead',
    lead_create_submit: 'Create lead',
    lead_assign_now: 'Assign to',
    lead_assign_now_hint: 'Optional. You can also assign later from the lead page.',
    confirm_archive: 'This lead will be hidden from the lists but keep its full history, and can be restored later. Are you sure?',
    confirm_unassign: 'Remove this lead from its current owner?',
    toast_lead_created: 'Lead created',
    toast_lead_updated: 'Changes saved',
    toast_lead_archived: 'Lead archived',
    toast_lead_restored: 'Lead restored',
    toast_assigned: 'Lead assigned',
    toast_assign_unchanged: 'The lead already belongs to this person',
    toast_unassigned: 'Lead unassigned',
    toast_bulk_assigned: '{n} assigned, {u} skipped (already theirs)',
    toast_stage_updated: 'Stage updated',

    // ---- stage dialog
    stage_dialog_title: 'Change stage',
    stage_move_to: 'Move to',
    stage_lost_reason: 'Lost reason',
    stage_lost_reason_placeholder: 'Choose a reason',
    stage_note: 'Note',
    stage_confirm: 'Confirm change',
    stage_won_terminal: 'This lead is Won and cannot be moved to another stage.',
    stage_no_moves: 'No stage changes are available for this lead right now.',
    stage_reopen_hint: 'This lead is marked Lost. You can reopen it by returning it to an early stage.',
    stage_assign_first_hint: 'Assign the lead to a Sales Employee first so it can move through the pipeline, or close it as Lost.',

    // ---- assign dialog
    assign_title: 'Assign lead',
    assign_title_bulk: 'Assign {n} leads',
    assign_hint: 'Only active team members who can receive leads are listed, with how many open leads each one has.',
    assign_pick: 'Choose a team member',
    assign_search: 'Search team members',
    assign_no_match: 'No matching team member',
    assign_none: 'Nobody can receive lead assignments right now.',
    assign_current: 'current owner',
    assign_open_leads: '{n} open',
    assign_confirm: 'Assign',

    // ---- duplicates
    dup_title_exact: 'Exact duplicate found',
    dup_title_possible: 'Possible duplicate found',
    dup_intro_exact: 'This looks like a lead or customer we already have. Review the existing record before creating another one.',
    dup_intro_possible: 'Similar records exist. Review them to make sure this is not the same business.',
    dup_live_hint: 'You can keep going - you will be asked to confirm when you save.',
    dup_kind_exact: 'Exact',
    dup_kind_possible: 'Possible',
    dup_leads: 'Existing leads',
    dup_companies: 'Existing JAZ customers',
    dup_archived: 'Archived',
    dup_owned: 'Assigned to {name}',
    dup_owned_other: 'Assigned to a colleague',
    dup_unassigned: 'Unassigned',
    dup_no_access: "You don't have access to open this lead",
    dup_open: 'Open',
    dup_confirm_create: 'Create anyway',
    dup_confirm_save: 'Save anyway',
    dup_needs_manager: 'You cannot continue: this is an exact duplicate and needs a Sales Manager to review it.',
    dup_similar_number: '(similar number, the country code may differ)',
    dup_r_phone_phone: 'Same phone number',
    dup_r_phone_whatsapp: 'Phone matches their WhatsApp number',
    dup_r_whatsapp_whatsapp: 'Same WhatsApp number',
    dup_r_whatsapp_phone: 'WhatsApp matches their phone number',
    dup_r_email_email: 'Same email address',
    dup_r_website_website: 'Same website',
    dup_r_business_name_business_name_city: 'Same business name in the same city',
    dup_r_email_owner_email: "Email of a JAZ customer company's owner",
    dup_r_phone_owner_phone: "Phone of a JAZ customer company's owner",
    dup_r_whatsapp_owner_phone: "WhatsApp matches a JAZ customer owner's phone",
    dup_r_business_name_company_name: 'Same name as a JAZ customer company',

    // ---- timeline
    lead_section_timeline_hint: 'A permanent record of everything that happened to this lead.',
    timeline_empty: 'No activity yet',
    timeline_empty_value: 'empty',
    timeline_by: 'by',
    timeline_automatic: 'automatic',
    timeline_reopened: 'reopened',
    timeline_nobody: 'nobody',
    timeline_dup_override: 'Created despite {n} confirmed match(es)',
    event_lead_created: 'Lead created',
    event_lead_updated: 'Details updated',
    event_lead_assigned: 'Lead assigned',
    event_lead_reassigned: 'Lead reassigned',
    event_lead_unassigned: 'Lead unassigned',
    event_stage_changed: 'Stage changed',
    event_lead_marked_won: 'Marked as won',
    event_lead_marked_lost: 'Marked as lost',
    event_lead_archived: 'Archived',
    event_lead_restored: 'Restored',

    // ---- campaigns
    campaigns_title: 'Campaigns',
    campaigns_add: 'Add campaign',
    campaigns_view_only: 'View only - campaigns are managed by the Sales Manager',
    campaigns_search_placeholder: 'Campaign name or description',
    campaigns_empty: 'No campaigns yet',
    campaigns_empty_filtered: 'No matching campaigns',
    campaigns_error: 'Could not load the campaigns',
    campaign_field_name: 'Campaign name',
    campaign_field_description: 'Description',
    campaign_field_status: 'Status',
    campaign_field_start: 'Start date',
    campaign_field_end: 'End date',
    campaign_dates: 'Period',
    campaign_leads: 'Leads',
    campaign_create_title: 'New campaign',
    campaign_edit_title: 'Edit campaign',
    confirm_delete_campaign: 'Delete the campaign "{name}"? A campaign that has leads cannot be deleted.',
    toast_campaign_created: 'Campaign created',
    toast_campaign_updated: 'Campaign saved',
    toast_campaign_deleted: 'Campaign deleted',

    // ---- pipeline board
    pipeline_title: 'Pipeline',
    pipeline_subtitle: 'Leads by sales stage, most recently updated first.',
    pipeline_empty_column: 'No leads',
    pipeline_view_all: 'View all {n}',

    // ---- errors (by server error code)
    err_forbidden: "You don't have permission to do that",
    err_not_found: 'The requested item was not found',
    err_lead_archived: 'This lead is archived. Restore it to make any change.',
    err_assignee_not_eligible: 'The lead cannot be assigned to this person. They must be an active Sales Employee who works leads.',
    err_transition_not_allowed: 'The lead cannot move to that stage from where it is now.',
    err_same_stage: 'The lead is already in that stage.',
    err_assignee_required: 'Assign the lead to a Sales Employee before moving it to that stage.',
    err_unassign_required: 'Unassign the lead before returning it to the New stage.',
    err_lost_reason_required: 'Choose a lost reason.',
    err_lost_reason_not_allowed: 'A lost reason can only be given when marking a lead as lost.',
    err_invalid_lost_reason: 'Unknown lost reason.',
    err_campaign_has_leads: 'This campaign cannot be deleted because it has {n} lead(s). Mark it as completed instead.',
    err_duplicates_found: 'Duplicate records were found. Review them, then confirm to continue.',
    err_duplicate_override_forbidden: 'An exact duplicate needs a Sales Manager to review it.',
    err_leads_not_found: 'Some of the leads were not found.',
  },
};
